module.exports = __webpack_public_path__ + "static/media/bussiness.f3890262.svg";